<template>
  <div id="letter" style="padding: 0 1em;">
    <el-container
      v-loading.fullscreen.lock="$store.getters.getLoading"
      element-loading-text="資料载入中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="container" style="padding-left: 0; padding-right: 0;">
        <div v-bind:style="{'background': headerColor}" style="position: relative;">
            <div class="head_linker">
              <span style="padding: 1em 0 0;"
                  v-if="user.status=='8'">
                      <span style="font-weight:bolder; color:#003371; vertical-align: middle;">{{user.name}}{{user.type}} ,您好</span>&nbsp;&nbsp;
                      <a class="head_a" href="#" @click.prevent="logout()"> 登出 </a>
              </span>&nbsp;|&nbsp;
              <a class="head_a" href="https://www.ncut.edu.tw/" target="_blank"> {{$t('message.Home_txt')}} </a>
            </div>
            <h1 class="cy-header" v-bind:style="{'background-image': headerImg}" style="padding: 0.25rem; text-align: left;"><img src="@/assets/images/logo0506.png" style="height: 80px; " alt="NCUT勤益校徵圖示" title="碩士班招生" /><small class="text-muted" style="vertical-align: text-bottom; color: #1f2040!important;" v-if="setting!=null">{{setting.sysTitle[0].codeName}}</small></h1>

        </div>
      </div>
      <el-main style="padding:0;">
        <component v-bind:is="currentComponent" class="container" @toggle="setCurComp" @getDefaultMenu="getDefaultMenu" ></component>
      </el-main>
      <el-footer>
        <vFooter/>
      </el-footer>
    </el-container>
  </div> 
</template>

<script>
import Vue from 'vue'
import i18n from '@/i18n/lang'
import vFooter from '@/components/FooterView.vue'
import vTitle  from '@/components/TitlePage.vue'

export default {
  name: 'letter',
  data () {
    return {
      cn : null,
      userInfo: {
        eId: 0,
        gId: -1,
        dId: 0,
        stdId: -1,
        text1: '',
        text2: '',
        text3: '',
        isLogin: true
      },
      pageInfo: null,
      currentComponent: '',
      pageTitle: '',
      jsData: [],
      isIE: false
    }
  },
  components: {
    vFooter,
    vTitle,
    i18n
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    sysTitle () {
      return this.$store.getters.getSysTitle
    },
    headerDisplay () {
      return (this.isIE? 'ruby': 'contents');
    },
    headerImg () {
      let url = '';
      if (this.setting!=null && this.setting.headerFile != null && this.setting.headerFile[0]!= null && this.setting.headerFile[0].codeName.length>0) {
         url  = 'url(./WebApi/Tools/ShowSystemDoc/'.concat(this.$store.getters.getSysId).concat('/').concat(6).concat(')');
      }
      return url
    },
    headerColor () {
      let url = '';
      if (this.setting!=null && (this.setting.headerFile == null || this.setting.headerFile[0]== null || this.setting.headerFile[0].codeName.length==0)) {
         url  = 'linear-gradient(45deg,#fefcea 0%,#f1da36 100%)';
      }
      return url
    }
  },
  methods: {
    toggle: function (appId, pageId) {
      this.$store.dispatch('actionAppId', appId)
      this.$store.dispatch('actionPageId', pageId)
      this.setCurComp(this.pageInfo[appId].subMenu[pageId].path);
      this.setPageTitle();
    },
    setPageTitle: function() {
      let url = '';
      if ((this.pageInfo != null) && (this.$store.getters.getAppId > -1) && (this.$store.getters.getPageId > -1)) {
        var appId = this.$store.getters.getAppId
        var pageId = this.$store.getters.getPageId 
        url = this.pageInfo[appId].subMenu[pageId].title
      }
      this.$store.dispatch('setSysTitle', url)
    },
    setCurComp (evtValue) {
      if (evtValue !== null) {
        this.currentComponent = evtValue
      } else {
        this.currentComponent = 'Help'
      }
    },
    capitalizeFirstLetter: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    setComponent: function () {
      if ((this.pageInfo != null) && (this.pageInfo.length > 0)) {          
        var len = this.pageInfo[0].subMenu.length
        var vm = this
        const requireComponent = require.context('.', false, /\.vue$/)
        requireComponent.keys().forEach(fileName => {
          const componentConfig = requireComponent(fileName)
          // 因為得到的filename格式是: './baseButton.vue', 所以這裡我們去掉頭和尾，只保留真正的檔案名
          const componentName = vm.capitalizeFirstLetter(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
          var index = vm.jsData.indexOf(componentName);

          if (0 > index) {
            if (componentName === 'ModifyView') {
              Vue.component('Modify', componentConfig.default || componentConfig)
              vm.jsData.push(componentName);
            } else if (componentName === 'UploadView') {
              Vue.component('Upload', componentConfig.default || componentConfig)
              vm.jsData.push(componentName);
            } else {        
              var found = false
              for (var i = 0; i < len && !found; i++) {
                if (vm.pageInfo[0].subMenu[i].jsPath === componentName) {
                  //console.log('MainView: componentName=' + componentName + '    path:' + vm.pageInfo[0].subMenu[i].path)
                  Vue.component(vm.pageInfo[0].subMenu[i].path, componentConfig.default || componentConfig)
                  vm.jsData.push(componentName);
                  found = true
                }
              }    
            }
          }
        })
      }
    },
    getDefaultMenu: function (sId, flag) {
      var vm = this
      if (!flag || (this.pageInfo == null)) {
        this.$http
          .get('./WebApi/Common/GetMenuItem/'.concat(sId).concat('/').concat(this.$store.state.user.status))
          .then(function (response) {
            let appId = 0, pageId = 0, sort = 0;
            let cFlag = false;
            vm.pageInfo = response.data;
            vm.setComponent();            
            vm.setCurComp ('Modify');
            for (let i = 0; i < vm.pageInfo.length; i++) {
              if (null != vm.pageInfo[i].subMenu) {
                for (var j = 0; j < vm.pageInfo[i].subMenu.length; j++) {
                  if (sort < vm.pageInfo[i].subMenu[j].sort) {
                    appId = i;
                    pageId = j;
                    sort = vm.pageInfo[i].subMenu[j].sort;
                    cFlag = true;
                  }
                }
              }
            }
            if (cFlag) {
              vm.toggle(appId, pageId);
            }
          })
      }
    },
    logout: function () {
      var user = {
        eId: this.setting.enrollID[0].codeName,
        gId: -1,
        dId: -1,
        stdId: -1,
        text1: this.$store.state.user.id,
        text2: '',
        text3: '',
        isLogin: false
      }
      var vm = this
      this.$http.put('./WebApi/Common/Authorized', user)
        .then((response) => {
          if (response.data != null) {
            console.log('logout' + vm.user.id)
            vm.$store.dispatch('setSysMode', 0)
            vm.$store.dispatch('resetLogin');
            vm.$emit('getDefaultMenu', this.sysId, false);
            window.location.href = 'https://www.ncut.edu.tw/';
          } else {
            vm.$notify.error({
                              title: vm.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>登出失敗</strong>',
                              offset: 150
                            });
          }
        })
        .catch(function (error) {
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        })
    }      
  },
  created () {
    console.log('======created LetterView=====');
    var vm = this;
    var userAgent = navigator.vendor; 
    this.isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
    this.userInfo.text1 = this.$route.params.token;
    vm.$store.dispatch('setSysMode', 1);
    this.$http.put('./WebApi/Common/RecAuthorized', this.userInfo)
              .then((response) => {
                var tmpData = response.data
                console.log('set Authorized' + tmpData.usrData.id);
                vm.$notify({
                              title: '成功',
                              dangerouslyUseHTMLString: true,
                              message: '<strong><i style="background:yellow;">'+tmpData.usrData.name+'</i>登入成功</strong>',
                              type: 'success',
                              offset: 150
                          });
                //vm.$store.dispatch('setSysMode', 1)
                vm.$store.dispatch('actionLogin', tmpData.usrData);
                vm.getDefaultMenu(this.sysId, false);
              })
              .catch(function (error) {
                vm.$notify.error({
                                    title: '錯誤',
                                    dangerouslyUseHTMLString: true,
                                    message: '<strong>對不起參數錯誤無法登入!!!</strong>',
                                    offset: 150
                                });
              })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  display: contents;
}
.head_a {
  color: white;
  text-decoration: none;
  font-size: 12px;
  font-family: verdana, 'trebuchet ms', sans-serif;
}
.head_linker {
  background-color: rgba(33,99,33, 0.2);
  position: absolute;
  right: 0.25rem;
  top: 0.125rem;
}
</style>



// WEBPACK FOOTER //
// src/components/LetterView.vue